<template>
  <v-container class="custom-container">
    <v-container fluid class="pa-0 custom-container">
      <v-layout justify-center row>
        <v-flex xs12>
          <v-toolbar color="#15216a" dark class="custom" height="48">
            <v-toolbar-title>Create Product</v-toolbar-title>
          </v-toolbar>
          <v-card>
            <v-layout align-center class="pa-2">
              <v-btn outline color="grey darken-2" dark>
                <v-icon dark left>arrow_back</v-icon>Back / Cancel
              </v-btn>
              <v-switch
                v-model="draft"
                label="Draft"
                color="indigo darken-3"
                :value="draft"
                hide-details
                class="ma-0"
              ></v-switch>
              <v-btn color="#3384e8" dark>
                <v-icon dark left>save</v-icon>Save
              </v-btn>
              <v-btn color="#3384e8" dark>
                <v-icon dark left>save</v-icon>Save & Exit
              </v-btn>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <br />
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout>
          <v-flex xs12>
            <v-tabs class="custom-tab">
              <v-tab ripple>Create Product</v-tab>
              <v-tab ripple>Create Grouping Product</v-tab>
              <v-tab-item>
                <CreateProduct :product="product" />
              </v-tab-item>
              <v-tab-item>
                <CreateGroupingProduct :product="product" />
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-layout>
        <v-card flat class="custom-card mt-3">
          <v-card-text>
            <v-layout justify-space-between align-center>
              <v-switch v-model="product.is_active" color="primary"></v-switch>
              <v-btn color="#3384e8" dark @click="save">
                <v-icon dark left>save</v-icon>Save
              </v-btn>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-form>
      <br />
      <br />
    </v-container>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import CreateProduct from "./Product/Create";
import CreateGroupingProduct from "./GroupingProduct/Create";
export default {
  components: {
    CreateProduct,
    CreateGroupingProduct
  },
  data: () => ({
    product: {
      product_number: "",
      item_name: "",
      kategori_id: "",
      brand_id: "",
      principal_id: "",
      tags: "",
      picture: "",
      thumbnail: "",
      item_status: true,
      barcode: "",
      description: "",
      sku: "",
      uom_code: "",
      uom_name: "",
      conversation_qty: "",
      normal_price: "",
      item_price: "",
      het_price: "",
      qty_tier: "",
      discount_tier: "",
      periodic_stock: "",
      is_active: true,

      grouping_product: {
        name: "",
        description: "",
        product_id: "",
        uom_id: "",
        qty: "",
        price: ""
      }
    },
    valid: true,
    draft: false
  }),

  methods: {
    ...mapActions({
      createProduct: "product/CreateProduct"
    }),
    save() {
      if (this.$refs.form.validate()) {
        this.createProduct(this.product);
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style>
.custom-tab .v-tabs__bar {
  background-color: transparent;
}
.custom-tab .v-tabs__item--active {
  background-color: #15216a !important;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  color: #fff;
}
</style>
